import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'castnumberarray' })
export class CastNumberArrayPipe implements PipeTransform {
  transform(n: any): number[] { return n as number[]; }
}
